import React from "react";
import CrudPage from "../components/CrudPage";
import { naira } from "../lib/format";
import StatusBadge from "../components/StatusBadge";
export default function Customers() {
  const columns = [
    { key: "name", label: "Customer", render: (r) => <span className="font-medium" style={{ color: "#3B2722" }}>{r.name}</span> },
    { key: "customer_type", label: "Type" }, { key: "phone", label: "Phone" },
    { key: "loyalty_points", label: "Points", align: "right", render: (r) => <span style={{ color: "#C49A4A" }} className="font-semibold">{r.loyalty_points}</span> },
    { key: "balance", label: "Balance", align: "right", render: (r) => naira(r.balance) },
    { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
  ];
  const fields = [
    { name: "name", label: "Customer Name", required: true, full: true },
    { name: "customer_type", label: "Type", type: "select", default: "Retail", options: [{ value: "Retail", label: "Retail" }, { value: "Corporate", label: "Corporate" }] },
    { name: "phone", label: "Phone" }, { name: "email", label: "Email" },
    { name: "address", label: "Address", type: "textarea", full: true },
  ];
  return <CrudPage title="Customers" subtitle="Unified customer & loyalty records" module="customers" endpoint="/customers" columns={columns} fields={fields} searchKeys={["name", "phone", "email"]} testId="customers" addLabel="New Customer" defaults={{ customer_type: "Retail" }} />;
}
